import { render, staticRenderFns } from "./PrmOverview.vue?vue&type=template&id=13be538e&scoped=true&"
import script from "./PrmOverview.vue?vue&type=script&lang=js&"
export * from "./PrmOverview.vue?vue&type=script&lang=js&"
import style0 from "./PrmOverview.vue?vue&type=style&index=0&id=13be538e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13be538e",
  null
  
)

component.options.__file = "PrmOverview.vue"
export default component.exports